import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import css from './AdBasicAttributes.desktop.scss';
import { getTitleAndHeadingFromInspection } from 'Helpers/item';
import ImageWrapper from 'Components/ImageWrapper/ImageWrapper';
import { WEBP_SVG_TYPE, XX, MODE } from 'Constants/images';
import OwnerTags from '../OwnerTags/OwnerTags';
import withConfig from 'HOCs/withConfig/withConfig';
import { KYC } from 'Constants/users';
import ReservedTags from '../ReservedTags/AsyncReservedTags';
// import AsyncMembershipTagV1 from 'Components/MembershipTagV1/AsyncMembershipTagV1';
// import MembershipTagV1 from 'Components/MembershipTagV1/MembershipTagV1';
// import { CONFIG } from 'Constants/config';
// import { HIGHLIGHT_TAG } from 'Constants/imageUrls';
// import { FEATURED_TAG } from 'Components/Listing/components/constants';

export class AdBasicAttributes extends React.PureComponent {
    static propTypes = {
        item: PropTypes.object.isRequired,
        cssClass: PropTypes.string,
        isGalleryOverlay: PropTypes.bool,
        user: PropTypes.object.isRequired,
        config: PropTypes.shape({
            get: PropTypes.func.isRequired
        }).isRequired,
        children: PropTypes.oneOfType([
            PropTypes.element,
            PropTypes.array,
            PropTypes.string
        ])
    };
    static defaultProps = {
        cssClass: '',
        isGalleryOverlay: false
    };

    keys = this.props.config.get('adpvAuto', 'keys');

    render() {
        const { item, cssClass, isGalleryOverlay, user, config } = this.props;
        const itemBasicParameters = item.inspectionDetails && item.inspectionDetails.basicInfo
            && item.inspectionDetails.basicInfo.parameters || [];
        const isTR = config.get('siteCode') === 'olxtr';
        const { makeModelYear, variant, yearMakeModel } = getTitleAndHeadingFromInspection(item, this.keys);
        const mode = isGalleryOverlay ? MODE.DARK : MODE.LIGHT;
        const { 'package': appliedPackage, monetizationInfo } = item;
        const isVerifiedSeller = !!(item?.is_kyc_verified_user || user?.kyc?.status === KYC.VERIFIED);
        const h2Parameters = ['fuel', 'transmission'];
        const isOlxMobbi = config.get('isOlxMobbi');
        const hasPromotion = item && item.has_promotion ? item.has_promotion : false;
        const discountAmountValue = item?.price?.value?.discount_tag;

        return (
            <div className={ classNames(css.basicInfoWrapper, cssClass, css.bg) }>
                <div className={ css.basicInfo }>
                    <div className={ css.rowInfo }>

                        { monetizationInfo && <OwnerTags
                            user={ user }
                            appliedPackage={ appliedPackage }
                            monetizationInfo={ monetizationInfo }
                            isVerifiedSeller={ isVerifiedSeller }
                            hasPromotion={ hasPromotion }
                            discountPrice={ discountAmountValue }
                            MembershipTag={ !isOlxMobbi }
                        />
                        }

                        {item?.reserve
                            && <ReservedTags
                                reserveData={ item?.reserve }
                                itemId={ item?.id }
                            />
                        }
                        {this.props.children}
                    </div>
                    <h1 className={ css.title } data-aut-id="itemTitle">
                        {isTR ? yearMakeModel.toLowerCase() : makeModelYear.toLowerCase()}
                    </h1>
                    <div className={ css.subTitle }>{variant}</div>
                    {itemBasicParameters.length > 0
                        && <div className={ css.flexContainer } data-aut-id="itemParameters">
                            {itemBasicParameters.map(info =>
                                (<div
                                    key={ info.key }
                                    className={ classNames(css.flexItem, { [css.whiteBorder]: isGalleryOverlay }) }
                                >
                                    {info.imageURI && <ImageWrapper
                                        fileName={ info.imageURI }
                                        fileSize={ XX }
                                        className={ css.img }
                                        alt={ info.value }
                                        mode={ mode }
                                        types={ WEBP_SVG_TYPE }
                                    />}
                                    {h2Parameters.includes(info.key) ? (
                                        <h2 className={ css.itemName } data-aut-id={ `itemAttribute_${info.key}` }>
                                            {info.value}
                                        </h2>
                                    ) : (
                                        <div className={ css.itemName } data-aut-id={ `itemAttribute_${info.key}` }>
                                            {info.value}
                                        </div>
                                    )}
                                </div>)
                            )}
                        </div>
                    }
                </div>
            </div>
        );
    }
}

export default withConfig(AdBasicAttributes);
